/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Dialog, FilledButton, OutlinedButton } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = (props: { isOpen: boolean }) => {
  const [variant, setVariant] = useState<
    React.ComponentProps<typeof Dialog>['variant'] | undefined
  >(undefined);
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);
  const handleClick = (
    variant: React.ComponentProps<typeof Dialog>['variant'],
  ) => {
    setVariant(variant);
    setIsOpen((prev) => !prev);
  };
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <div className="n-flex n-justify-center n-gap-token-16">
        <FilledButton
          onClick={() => handleClick('info')}
          htmlAttributes={{ 'aria-haspopup': 'dialog' }}
        >
          Info Dialog
        </FilledButton>
        <FilledButton
          onClick={() => handleClick('warning')}
          htmlAttributes={{ 'aria-haspopup': 'dialog' }}
        >
          Warning Dialog
        </FilledButton>
        <FilledButton
          onClick={() => handleClick('danger')}
          htmlAttributes={{ 'aria-haspopup': 'dialog' }}
        >
          Danger Dialog
        </FilledButton>
      </div>
      <Dialog
        htmlAttributes={{
          id: `${variant}-dialog`,
        }}
        onClose={handleClose}
        isOpen={isOpen}
        variant={variant}
      >
        <Dialog.Header>Header</Dialog.Header>
        <Dialog.Subtitle>This is a subtitle</Dialog.Subtitle>
        <Dialog.Description>This is a description</Dialog.Description>
        <Dialog.Actions>
          <OutlinedButton onClick={handleClose} variant="neutral" size="medium">
            Secondary
          </OutlinedButton>
          <FilledButton onClick={handleClose} size="medium">
            Primary
          </FilledButton>
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default Component;
